import styled from "styled-components";

export const UserInfoEditContentLayout = styled.form`
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: start;

  .contentBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 24px;
    margin-bottom: 50px;
  }
`;

export const UserPasswordEditContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const UserEditContentTitlBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  .pointText {
    font-size: 1.4rem;
    font-weight: 600;
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const UserEditContentTitle = styled.p`
  font-size: 1.6rem;
  font-weight: 500;
`;

export const InputLabelText = styled.label`
  position: absolute;
  top: -9px;
  left: 6px;
  font-size: 1.4rem;
  font-weight: 600;
  background: ${(props) => props.theme.colors.white};
  padding: 0 6px;
  color: ${(props) => props.theme.colors.placeholderTxt};
`;

export const InputBox = styled.div`
  width: 100%;

  &.userInfoDefault {
    position: relative;
  }

  input {
    width: 100%;
    border: 1px solid ${(props) => props.theme.colors.inputBorder};
    border-radius: 10px;
    padding: 16px;
    background: none;
    font-size: 1.4rem;
    font-weight: 500;
    color: ${(props) => props.theme.colors.black};

    &:focus {
      border: 1px solid ${(props) => props.theme.colors.primary};

      & + ${InputLabelText} {
        color: ${(props) => props.theme.colors.primary};
      }
    }

    ::placeholder {
      color: ${(props) => props.theme.colors.placeholderTxt};
    }
  }

  @media (min-width: 412px) {
    padding: 12px;
  }
`;

export const UserDefaultInfoEditContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 21px;
`;

export const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  grid-row: 3/3;

  .small {
    width: 40%;
  }
`;

export const ButtonWrap = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  height: 100vh;
`;
